var _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIllustrationLogo3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 139,
    height: 123,
    viewBox: "0 0 139 123",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6031_754)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.8
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.4601 119.51C80.8953 119.51 95.8401 104.566 95.8401 86.1305C95.8401 67.6952 80.8953 52.7505 62.4601 52.7505C44.0248 52.7505 29.0801 67.6952 29.0801 86.1305C29.0801 104.566 44.0248 119.51 62.4601 119.51Z",
    fill: "#00A5D5"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.8
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M67.23 34.0103C76.05 34.0103 83.2 26.8603 83.2 18.0403C83.2 9.22033 76.05 2.07031 67.23 2.07031C58.41 2.07031 51.26 9.22033 51.26 18.0403C51.26 26.8603 58.41 34.0103 67.23 34.0103Z",
    fill: "#FFDF00"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.8
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M95.68 55.8204C108.78 55.8204 119.4 45.2006 119.4 32.1004C119.4 19.0002 108.78 8.38037 95.68 8.38037C82.5798 8.38037 71.96 19.0002 71.96 32.1004C71.96 45.2006 82.5798 55.8204 95.68 55.8204Z",
    fill: "#FF009D"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M49.22 13.5801L1.21997 58.6901V122H64.4L95.22 90.5801",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.01 77.9701L109.4 0.850098",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M63.1799 75.5501L137.84 0.850098",
    stroke: "black",
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6031_754"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 137.47,
    height: 122,
    fill: "white",
    transform: "translate(0.719971 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationLogo3);
export default __webpack_public_path__ + "static/media/illustration-logo-3.4dd092affee44729ed4ea5a1bdeaf7df.svg";
export { ForwardRef as ReactComponent };